import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { fromUnixTime, isPast } from 'date-fns';
import { userModel } from 'entities/user';
import { checkRequestStatusEquality, RequestStatus, Spinner, uiSelector, useShallowSelector } from 'shared';
import { useWeb3Provider } from 'shared/config/wallet-connect';
import { AirDrop, Exchange } from 'widgets';
import { userActions } from '../../entities/user/model';
import { PageWrapper } from 'shared/ui/PageWrapper';

const SwapPageContent = () => {
  const { startTime, finish } = useShallowSelector(userModel.selectors.selectVestingSwapInfo);
  const isSwapFinished = useMemo(() => isPast(fromUnixTime(+finish)), [finish]);

  const uiState = useShallowSelector(uiSelector);
  const isFetching = checkRequestStatusEquality(uiState[userActions.getVestingSwapInfo?.type], RequestStatus.REQUEST);

  if (isFetching) return <Spinner sx={{ margin: 4 }} />;
  return startTime && finish && isSwapFinished ? <AirDrop /> : <Exchange />;
};

export const SwapPage = () => {
  const dispatch = useDispatch();
  const web3Provider = useWeb3Provider();

  useEffect(() => {
    dispatch(userModel.userActions.getVestingSwapInfo({ web3Provider }));
  }, [dispatch, web3Provider]);

  return (
    <PageWrapper title="Stars exchange" subTitle="Seamless Swaps, Infinite Possibilities">
      <SwapPageContent />
    </PageWrapper>
  );
};
